
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { addItem, removeItem, removeItemTime } from '@/utils/arrays'
import { setProductAccount } from '@/api/product/productAccount'
import { strToDateArray, timeJoin } from '@/utils/dateTime'
@Component({
  name: 'editAccountLimitation',
  components: {},
})
export default class extends Vue {
  @Prop({ default: {} }) account!: any
  @Prop({ default: true }) isEdit!: boolean

  private loading: boolean = false
  private form: any = {
    daily_limited_volume: 0,
    daily_limited_transaction: 0,
    min_amount: 0,
    max_amount: 0,
    open_time: [],
    hook_info: {
      choice_product_account_config: {
        status: 0,
        frequency: '',
      },
    },
  }

  private openTimes: any[] = [
    [new Date('2024/01/01 00:00'), new Date('2024/01/01 23:59')],
  ]

  private addItem = addItem
  // private removeItem = removeItem
  private removeItem = removeItemTime

  private changeStatus(e: any) {
    if (e === 0) {
      this.form.hook_info.choice_product_account_config.frequency = ''
    } else {
      this.form.hook_info.choice_product_account_config.frequency = '1'
    }
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private async update() {
    this.loading = true
    this.flag = true
    this.openTimes.forEach((time: any) => {
      if (time[0]) {
        const str = timeJoin(time[0], time[1])
        this.form.open_time.push(str)
      }
    })

    if (!this.form.daily_limited_volume) {
      this.form.daily_limited_volume = 0
    }
    if (!this.form.daily_limited_transaction) {
      this.form.daily_limited_transaction = 0
    }

    if (!this.form.min_amount) {
      this.form.min_amount = 0
    }
    if (!this.form.max_amount) {
      this.form.max_amount = 0
    }
    if (!this.form.open_time) {
      this.form.open_time = []
    }
    const data: any = {
      ...this.form,
      id: this.account.id,
    }

    await setProductAccount(data).then((res: any) => {
      this.$message({
        message: 'Save successful!',
        type: 'success',
      })
      this.loading = false
      this.flagStr()
      this.$emit('next')
    })
  }

  @Watch('account')
  private onAccountChange() {
    const times: any[] = this.account.open_time
    if (times && times.length > 0) {
      this.openTimes = []
      times.forEach((time: any) => {
        this.openTimes.push(strToDateArray(time))
      })
      this.form.open_time = []
    }

    this.form.daily_limited_volume = this.account.daily_limited_volume
    this.form.daily_limited_transaction = this.account.daily_limited_transaction
    this.form.min_amount = this.account.min_amount
    this.form.max_amount = this.account.max_amount
    if (
      this.account.hook_info &&
      this.account.hook_info.choice_product_account_config
    ) {
      this.form.hook_info.choice_product_account_config.status =
        this.account.hook_info.choice_product_account_config.status
      this.form.hook_info.choice_product_account_config.frequency =
        this.account.hook_info.choice_product_account_config.frequency
    }
  }

  mounted() {}
}
